/**
 * Matches `{{ name }}` placeholders in a prompt body. Mirrors the pattern prompt
 * bodies are authored against and irwin-fe's promptTemplate.js. The `g` flag makes
 * this stateful — construct a fresh RegExp per scan. The name group allows empty so
 * `{{}}` is captured as `''` and reported as unknown instead of silently ignored.
 */
export const SELECTOR_PLACEHOLDER_PATTERN = /\{\{\s*([a-z0-9_]*)\s*\}\}/gi

/**
 * Returns placeholder names in `body` that are not in `validNames`.
 * Valid names come from GET /v2/agentic/metadata, so they are passed in rather than
 * closed over a bundled registry.
 * @param {string} body - The prompt body text
 * @param {Set<string>|string[]} validNames - Known selector type names
 * @returns {string[]} Unknown names, de-duplicated, or [] when all are valid
 */
export function findUnknownSelectorTypes(body, validNames) {
  if (!body) {
    return []
  }

  const validSet = validNames instanceof Set ? validNames : new Set(validNames || [])
  const unknownNames = new Set()
  const regex = new RegExp(SELECTOR_PLACEHOLDER_PATTERN)

  let match = regex.exec(body)
  while (match !== null) {
    const name = match[1]
    if (!validSet.has(name)) {
      unknownNames.add(name)
    }
    match = regex.exec(body)
  }

  return Array.from(unknownNames)
}
